import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { TimeService } from 'src/app/time.service';

@Component({
  selector: 'app-express-details',
  templateUrl: './express-details.component.html',
  styleUrls: ['./express-details.component.scss']
})
export class ExpressDetailsComponent implements OnInit {
  orderData:any;
  constructor(private dialogRef: MatDialogRef<ExpressDetailsComponent>,public timeService: TimeService , @Inject(MAT_DIALOG_DATA) private parentData: any,) { }

  ngOnInit() {
    this.orderData=this.parentData;
   
  }
  toShortDateTime(value) {
    return (value) ? this.timeService.toShortDateTime(value) : 'N/A';
  }
  closeModal() {
    this.dialogRef.close();
  }
}
